<template>
    <VDialog v-model="visivel" max-width="600px">
        <Loading ref="loading"/>
        <VCard>
            <VCardTitle>
                <span class="headline">Adicionar prospect</span>
            </VCardTitle>
            <VCardText>
                <VContainer grid-list-md>
                    <VForm ref="form">
                        <VLayout wrap>
                            <VFlex md12>
                                <VTextField label="Nome" prepend-icon="perm_contact_calendar"
                                            v-model="clienteForm.nome"
                                            color="primary"
                                            :rules="[rules.obrigatorio(), rules.tamanho(90)]"
                                            :counter="90"/>
                            </VFlex>
                           <VRadioGroup md12
                              v-model="tipoDocumentoRB"
                              @change="changeTipoRB($event)">
                              <VLayout>
                                <VFlex>
                                  <VRadio id="CPF" label="CPF" value="CPF"/>
                                </VFlex>
                                <VFlex>
                                  <VRadio id="CNPJ" label="CNPJ" value="CNPJ"/>
                                </VFlex>
                                <VFlex>
                                  <VRadio id="RNE" label="RNE" value="RNE"/>
                                </VFlex>
                              </VLayout>
                            </VRadioGroup>
                          <VFlex md12>
                            <VAutocomplete
                              v-model="clienteForm.nacionalidade"
                              label="Nacionalidade"
                              prepend-icon="public"
                              :items="nacionalidades"
                              item-value="id"
                              item-text="nome"
                              color="primary"
                              return-object
                              v-if="tipoDocumentoRB == 'RNE'"
                              :rules="[
                              rules.obrigatorio(),
                              ]"
                            />
                          </VFlex>
                          <VFlex md12>
                            <VTextField
                              id="campoCPF"
                              label="Insira o número do CPF"
                              prepend-icon="call_to_action"
                              v-model="clienteForm.documento.numDocumento"
                              mask="###.###.###-##"
                              v-if="tipoDocumentoRB == 'CPF'"
                              :rules="[
                              rules.obrigatorio(this.parametros.configuracoesClientes.crmCadastroPropectDocumentoObrigatorio),
                              rules.cpf,
                              ]"
                            ></VTextField>
                            <VTextField
                              id="campoCNPJ"
                              label="Insira o número do CNPJ"
                              prepend-icon="call_to_action"
                              v-model="clienteForm.documento.numDocumento"
                              mask="##.###.###/####-##"
                              :rules="[
                              rules.tamanho(14),
                              rules.obrigatorio(this.parametros.configuracoesClientes.crmCadastroPropectDocumentoObrigatorio),
                              rules.cnpj,
                              ]"
                              v-if="tipoDocumentoRB == 'CNPJ'"
                            ></VTextField>
                            <VTextField
                              id="campoRNE"
                              label="Insira o número do RNE"
                              prepend-icon="call_to_action"
                              v-model="clienteForm.documento.numDocumento"
                              mask="####################"
                              v-if="tipoDocumentoRB == 'RNE'"
                              :rules="[
                              rules.obrigatorio(this.parametros.configuracoesClientes.crmCadastroPropectDocumentoObrigatorio),
                              ]"
                            ></VTextField>
                          </VFlex>
                          <VFlex md12>
                                <VTextField
                                    label="Email"
                                    prepend-icon="mail"
                                    v-model="clienteForm.email"
                                    :rules="[
                                        rules.obrigatorio(this.parametros.configuracoesClientes.crmCadastroPropectEmailObrigatorio),
                                    ]"
                                  ></VTextField>
                          </VFlex>
                          <VFlex md4>
                              <VTextField label="Área" prepend-icon="location_on"
                                          v-model="clienteForm.telefone.area"
                                          color="primary"
                                            :rules="[
                                              rules.obrigatorio(this.parametros.configuracoesClientes.crmCadastroPropectTelefoneObrigatorio),
                                              ]"
                                          mask="###"/>
                          </VFlex>

                          <VFlex md8>
                              <VTextField label="Telefone" prepend-icon="phone"
                                          v-model="clienteForm.telefone.numero"
                                          color="primary"
                                          :rules="[
                                              rules.obrigatorio(this.parametros.configuracoesClientes.crmCadastroPropectTelefoneObrigatorio),
                                              rules.validarFormatoTelefone(clienteForm.telefone.area, clienteForm.telefone.numero)
                                              ]"
                                          :mask="mascaraCommon.mascaraTelefoneProspect(this.clienteForm.telefone.numero)"
                                          />
                          </VFlex>
                        </VLayout>
                    </VForm>
                </VContainer>
            </VCardText>
            <VCardActions>
                <VSpacer></VSpacer>
                <VBtn color="red darken-1" flat @click="fechar">Cancelar</VBtn>
                <VBtn small class="primary" @click="enviar">Salvar</VBtn>
            </VCardActions>
        </VCard>
    </VDialog>
</template>

<script>
import forms from '@/common/forms';
import Loading from '@/components/Dialog/Loading';
import ApiService from "../../common/api.service";
import alerts from '@/common/alerts';
import maskCommon from '@/common/mask';
import { mapState } from "vuex";

export default {
  name: "CadastroCliente",
  components: {
      Loading
  },
  props: {
      value: Boolean,
      cliente: Object
  },
  data() {
    return {
      visivel: false,
      rules: forms.rules,
      mascaraCommon: maskCommon,
      tipoDocumentoRB: "CPF",
      clienteForm: {
        nome: null,
        email:null,
        telefone: {
          area: null,
          numero: null,
        },
        documento: {
          id: 0,
          numDocumento: null,
          tipoDocumento: ''
        },
        servicosAdquiridos: [],
        nacionalidade: null
      },
      nacionalidades:{
        id: null,
        nome: "Nenhuma nacionalidade selecionada",
      },
    }
  },
  watch: {
    value(v) {
      this.visivel = v;
    },
    visivel(v) {
      if (v !== this.value)
        this.$emit('input', v);
    }
  },
  async activated() {
    try {
       this.tipoDocumentoRB = this.cliente.documento.tipoDocumento;
    } catch (e) {
      null
    }
  },
  methods: {
    async retornaNacionalidades() {
      ApiService.get(`clientes/nacionalidade`)
      .then(response => {
        this.nacionalidades = response.data;
      }).catch (error => {
        alerts.exibirErro(
        "Não foi possível buscar as nacionalidades",
        error
      )});
    },
    async enviar() {
      this.clienteForm.documento.tipoDocumento = this.tipoDocumentoRB;
      if (this.$refs.form.validate()) {
        try {
          var respostas = await this.$refs.loading.aguardarPromises([ApiService.post('clientes', this.clienteForm)], 'Salvando');
          this.clienteForm.id = respostas[0].data;
          this.$emit('update:cliente', {
            id: this.clienteForm.id,
            nome: this.clienteForm.nome,
            email: this.clienteForm.email,
            telefoneGeral: this.clienteForm.telefone.area + this.clienteForm.telefone.numero,
            documento: {
              id: 0,
              numDocumento: this.clienteForm.documento.numDocumento,
              tipoDocumento: this.clienteForm.documento.tipoDocumento
            },
            servicosAdquiridos: []
          });
          this.fechar();
        } catch (e) {
          alerts.exibirErro('Falha ao inserir os dados do prospect', e);
        }
      }
    },
    async changeTipoRB(tipo) {
      if (tipo == 'RNE') await this.retornaNacionalidades();
      this.clienteForm.tipoDocumento = tipo;
      this.tipoDocumentoRB = tipo;
    },
    fechar() {
      this.clienteForm = {
        nome: null,
        email:null,
        telefone: {
          area: null,
          numero: null
        },
        documento: {
          id: 0,
          numDocumento: null,
          tipoDocumento: 'CPF'
        }
      };
      this.$refs.form.resetValidation();
      this.$emit('input', false);
    }
  },
  computed: {
    ...mapState(["parametros"]),
  },
}
</script>

<style scoped>

</style>
